// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalBody_container__2V8lZ","topDivider":"ModalBody_topDivider__2f2Kr","bottomDivider":"ModalBody_bottomDivider__U51MU"};